module.exports = __webpack_public_path__ + "img/decce1d6d3d5f0018572f0ae18d910361ed28693 (1).92d41e64.jpg";